<template>
  <div class="popup-main">
    <el-dialog
      width="940px"
      title="批量引用类目材质"
      :visible.sync="selfShow"
      :close-on-click-modal="false"
    >
      <el-form ref="refForm" label-width="100px">
        <el-form-item label="当前类目:">
          <el-input v-model="categoryActiveName" size="mini" disabled />
        </el-form-item>
        <el-form-item label="引用类目:">
          <!-- <el-select size="mini" :style="{ width: '100%' }" v-model="categoryImportId">
            <el-option
              v-for="(item, index) in categoryList"
              :key="index"
              :label="item.key"
              :value="item.val"
            />
          </el-select> -->
          <b-goods-category :ids="categoryIds" @success="getCategoryActiveList" />
          <vxe-grid v-bind="tableOptions" ref="refTable" :data="tableList" class="m-t-10" />
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button size="mini" @click="popupCancel">取消</el-button>
        <el-button size="mini" type="primary" @click="popupConfirm">确认</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  props: {
    show: {
      type: Boolean,
      required: true
    },
    categoryIds: {
      type: Array,
      required: true
    },
    obj: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      selfShow: false,
      timer: null,
      categoryActiveList: [],
      categoryActiveName: '',
      // categoryImportId: '',
      // categoryList: [],
      tableOptions: {
        ref: 'refTable',
        size: 'mini',
        border: true,
        columns: [
          {
            type: 'checkbox',
            width: 40
          },
          {
            title: '材质名称',
            field: 'cai_zhi'
          },
          { title: '密度', field: 'val' }
        ]
      },
      tableList: []
    }
  },
  watch: {
    selfShow(val) {
      this.$emit('update:show', val)
    },
    categoryActiveList: {
      handler(val) {
        if (this.timer) clearTimeout(this.timer)
        this.timer = setTimeout(() => {
          let len = val.length
          if (len) this.getCaizhiList(val[len - 1].id)
          this.timer = null
        }, 500)
      },
      deep: true,
      immediate: true
    }
    // categoryImportId(val) {
    //   if (val) {
    //     this.getCaizhiList(val)
    //   }
    // }
  },
  mounted() {
    this.selfShow = this.show
    this.categoryActiveName = this.obj.name
    // this.getCategoryList()
  },
  methods: {
    // 获取选中类目列表
    getCategoryActiveList(list) {
      this.categoryActiveList = []
      list.forEach((itemSt) => {
        itemSt.category.forEach((itemNd) => {
          if (itemSt.title.active_id === itemNd.id) {
            this.categoryActiveList.push(this.$util.deepCopy(itemNd))
          }
        })
      })
    },
    // 获取同级类目列表
    // getCategoryList() {
    //   this.$api({
    //     method: 'post',
    //     url: '/admin/gcvip/columnData/list',
    //     data: {
    //       id: this.obj.parent_id
    //     }
    //   })
    //     .then((res) => {
    //       if (res.data.state === 'ok') {
    //         let result = res.data.list.filter((item) => {
    //           return item.id !== this.obj.id && !item.has_children
    //         })
    //         this.categoryList = result.map((item) => {
    //           return {
    //             key: item.name,
    //             val: item.id
    //           }
    //         })
    //         if (!this.categoryImportId && this.categoryList.length) {
    //           this.categoryImportId = this.categoryList[0].val
    //         }
    //       }
    //     })
    // },
    // 获取引用材质列表
    getCaizhiList(id) {
      this.$api({
        method: 'get',
        url: '/admin/gcvip/midu/list',
        params: {
          id
        }
      }).then((res) => {
        if (res.data.state === 'ok') {
          this.tableList = res.data.list
          this.$nextTick(() => {
            this.$refs.refTable.setAllCheckboxRow(true)
          })
        }
      })
    },
    // 弹窗取消
    popupCancel() {
      this.selfShow = false
      this.$emit('update:show', false)
    },
    // 弹窗确认
    popupConfirm() {
      let result = this.$refs.refTable.getCheckboxRecords()
      this.$emit('success', result)
      this.popupCancel()
    }
  }
}
</script>

<style lang="less" scoped>
.popup-main {
}
</style>
